import Api from '../api'
export default ({

  state: {
    crmClientLists: [],
    crmCompanyLists: [],
    crmCustomerLists: [],
    crmDealLists: [],
    crmProductLists: [],
    crmTaskLists: [],
    crmTicketLists: [],
    crmVisitorLists: [],
    crmFollowUpLists: [],
    crmNotReceivedCallsFollowUpLists: [],
    crmFollowUpListDateRangeLists: [],
    crmFollowQuotationLists: [],
    crmFollowSamleLists: [],
    crmFollowUpNotification: [],
    unreadNotificationCount: 0,
    crmAllFollowUpLists: []

  },
  mutations: {
    ADD_CLINET(state, client) {
      let crmClient = state.crmClientLists.concat(client)
      state.crmClientLists = crmClient
    },
    ADD_TASK(state, task) {
      let crmTaskList = state.crmTaskLists.concat(task)
      state.crmTaskLists = crmTaskList
    },
    ADD__CRM_CUSTOMER(state, customer) {
      let crmCustomerList = state.crmCustomerLists.concat(customer)
      state.crmCustomerLists = crmCustomerList
    },
    ADD_COMPANY(state, company) {
      let crmCompanyList = state.crmCompanyLists.concat(company)
      state.crmCompanyLists = crmCompanyList
    },
    ADD_DEAL(state, deal) {
      let crmDealList = state.crmDealLists.concat(deal)
      state.crmDealLists = crmDealList
    },
    ADD_PRODUCT(state, product) {
      let crmProductList = state.crmProductLists.concat(product)
      state.crmProductLists = crmProductList
    },
    ADD_TICKET(state, ticket) {
      let crmTicketList = state.crmTicketLists.concat(ticket)
      state.crmTicketLists = crmTicketList
    },
    ADD_FOLLOW_UP(state, followUp) {
      let crmFollowUpList = state.crmFollowUpLists.concat(followUp)
      state.crmFollowUpLists = crmFollowUpList
    },
    ADD_VISITOR(state, visitor) {
      let crmVisitorList = state.crmVisitorLists.concat(visitor)
      state.crmVisitorLists = crmVisitorList
    },
    DELETE_CLIENT(state, clientId) {
      let crmClient = state.crmClientLists.filter(a => a.id !== clientId.id)
      state.crmClientLists = crmClient
    },
    DELETE_CUSTOMER(state, customerId) {
      let crmCustomerList = state.crmCustomerLists.filter(customer => customer.id !== customerId.id)
      state.crmCustomerLists = crmCustomerList
    },
    DELETE_COMPANY(state, companyId) {
      let crmCompanyList = state.crmCompanyLists.filter(company => company.id !== companyId.id)
      state.crmCompanyLists = crmCompanyList
    },
    DELETE_DEAL(state, dealId) {
      let crmDealList = state.crmDealLists.filter(deal => deal.id !== dealId.id)
      state.crmDealLists = crmDealList
    },
    DELETE_PRODUCT(state, productId) {
      let crmProductList = state.crmProductLists.filter(product => product.id !== productId.id)
      state.crmProductLists = crmProductList
    },
    DELETE_VISITOR(state, visitorId) {
      let crmVisitorList = state.crmVisitorLists.filter(visitor => visitor.id !== visitorId.id)
      state.crmVisitorLists = crmVisitorList
    },
    DELETE_Task(state, taskId) {
      let crmTaskList = state.crmTaskLists.filter(task => task.id !== taskId.id)
      state.crmTaskLists = crmTaskList
    },
    DELETE_Follow_Up(state, followID) {
      let crmFollowUp = state.crmFollowUpLists.filter(task => task.id !== followID.id)
      state.crmFollowUpLists = crmFollowUp
    },
    DELETE_TICKET(state, ticketId) {
      let crmTicketList = state.crmTicketLists.filter(ticket => ticket.id !== ticketId.id)
      state.crmTicketLists = crmTicketList
    },
    SET_CLIENT(state, crmClientList) {
      state.crmClientLists = crmClientList
    },
    SET_COMPANY(state, crmCompanyList) {
      state.crmCompanyLists = crmCompanyList
    },
    SET_CRM_CUSTOMER(state, crmCustomerList) {
      state.crmCustomerLists = crmCustomerList
    },
    SET_DEAL(state, crmDealList) {
      state.crmDealLists = crmDealList
    },
    SET_PRODUCT(state, crmProductList) {
      state.crmProductLists = crmProductList
    },
    SET_TASK(state, crmTaskList) {
      state.crmTaskLists = crmTaskList
    },
    SET_TICKET(state, crmTicketList) {
      state.crmTicketLists = crmTicketList
    },
    SET_VISITOR(state, crmVisitorList) {
      state.crmVisitorLists = crmVisitorList
    },
    SET_FOLLOWUP(state, crmFollowUpList) {
      state.crmFollowUpLists = crmFollowUpList
    },
    SET_FOLLOWUP_ALL(state, crmAllFollowUpList) {
      state.crmAllFollowUpLists = crmAllFollowUpList
    },
    SET_UNREAD_COUNT(state, count) {
      state.unreadNotificationCount = count
    },
    REMOVE_NOTIFICATION(state, notificationId) {
      state.crmFollowUpNotification = state.crmFollowUpNotification.filter(item => {
        const fid = item.followUpNotificationDTO ? item.followUpNotificationDTO.followUpId : null
        const iid = item.unpaidInvoiceNotificationDTO ? item.unpaidInvoiceNotificationDTO.id : null
        return fid !== notificationId && iid !== notificationId
      })
    },
    REMOVE_NOTIFICATIONS(state, notificationIds) {
      state.crmFollowUpNotification = state.crmFollowUpNotification.filter(item => {
        const fid = item.followUpNotificationDTO ? item.followUpNotificationDTO.followUpId : null
        const iid = item.unpaidInvoiceNotificationDTO ? item.unpaidInvoiceNotificationDTO.id : null
        return !notificationIds.includes(fid) && !notificationIds.includes(iid)
      })
    },
    MARK_NOTIFICATIONS_AS_READ(state, notificationIds) {
      state.crmFollowUpNotification = state.crmFollowUpNotification.map(item => {
        const fid = item.followUpNotificationDTO.followUpId
        const iid = item.unpaidInvoiceNotificationDTO.id
        if (notificationIds.includes(fid) && item.followUpNotificationDTO) {
          return {
            ...item,
            notified: true,
            followUpNotificationDTO: {
              ...item.followUpNotificationDTO,
              notified: true
            }
          }
        }
        if (notificationIds.includes(iid) && item.unpaidInvoiceNotificationDTO) {
          return {
            ...item,
            notified: true,
            unpaidInvoiceNotificationDTO: {
              ...item.unpaidInvoiceNotificationDTO,
              notified: true
            }
          }
        }
        return item
      })
    },
    SET_FOLLOWUP_NOTIFICATION(state, notifications) {
      const flat = (notifications || [])
        .filter(n => n && (n.followUpNotificationDTO || n.unpaidInvoiceNotificationDTO))
        .flatMap(n => {
          const out = []
          if (n.followUpNotificationDTO && Object.keys(n.followUpNotificationDTO).length) {
            out.push({
              followUpNotificationDTO: n.followUpNotificationDTO,
              notified: !!n.followUpNotificationDTO.notified
            })
          }
          if (n.unpaidInvoiceNotificationDTO && Object.keys(n.unpaidInvoiceNotificationDTO).length) {
            out.push({
              unpaidInvoiceNotificationDTO: n.unpaidInvoiceNotificationDTO,
              notified: !!n.unpaidInvoiceNotificationDTO.notified
            })
          }
          return out
        })
      state.crmFollowUpNotification = flat
    },
    SET_FOLLOWUP_NOT_RECEIVED(state, crmNotReceivedCallsFollowUpList) {
      state.crmNotReceivedCallsFollowUpLists = crmNotReceivedCallsFollowUpList
    },
    SET_FOLLOWUP_DATE_RANGE(state, crmFollowUpDateRangeList) {
      state.crmFollowUpListDateRangeLists = crmFollowUpDateRangeList
    },
    SET_QUOTATION(state, crmFollowQuotationList) {
      state.crmFollowQuotationLists = crmFollowQuotationList
    },
    SET_SAMPLE(state, crmFollowSamleList) {
      state.crmFollowSamleLists = crmFollowSamleList
    },
    UPDATE_CLIENT(state, updateClient) {
      state.crmClientLists = state.crmClientLists.map(client => client.id !== updateClient.id ? client : {...client, ...updateClient})
    },
    UPDATE_CRM_CUSTOMER(state, updatedCustomer) {
      state.crmCustomerLists = state.crmCustomerLists.map(customer => customer.id !== updatedCustomer.id ? customer : {...customer, ...updatedCustomer})
    },
    UPDATE_COMPANY(state, updatedCompany) {
      state.crmCompanyLists = state.crmCompanyLists.map(company => company.id !== updatedCompany.id ? company : {...company, ...updatedCompany})
    },
    UPDATE_DEAL(state, updateDeal) {
      state.crmDealLists = state.crmDealLists.map(deal => deal.id !== updateDeal.id ? deal : {...deal, ...updateDeal})
    },
    UPDATE_PRODUCT(state, updateProduct) {
      state.crmProductLists = state.crmProductLists.map(product => product.id !== updateProduct.id ? product : {...product, ...updateProduct})
    },
    UPDATE_TASK(state, updateTask) {
      state.crmTaskLists = state.crmTaskLists.map(task => task.id !== updateTask.id ? task : {...task, ...updateTask})
    },
    UPDATE_TICKET(state, updateTicket) {
      state.crmTicketLists = state.crmTicketLists.map(task => task.id !== updateTicket.id ? task : {...task, ...updateTicket})
    },
    UPDATE_FOLLOW_UP(state, updateFollowUp) {
      state.crmFollowUpLists = state.crmFollowUpLists.map(task => task.id !== updateFollowUp.id ? task : {...task, ...updateFollowUp})
    },
    UPDATE_VISITOR(state, updateVisitor) {
      state.crmVisitorLists = state.crmVisitorLists.map(visitor => visitor.id !== updateVisitor.id ? visitor : {...visitor, ...updateVisitor})
    }
  },
  _actions: {
    async createCrmClient({ commit }, clinet) {
      let response = await Api.request('post', '/crmClients/createClients/' + this.state.fyId + '/' + this.state.organisationid + '/' + this.state.user.id + '', clinet)
      let saveClient = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_CLINET', saveClient)
      }
      return response
    },
    async updateCrmClient({ commit }, clinet) {
      let resp = await Api.request('put', '/crmClients/updateClients/' + clinet.id + '/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '', clinet)
      commit('UPDATE_CLIENT', resp.data.data)
      return resp
    },
    async createCrmCustomer({ commit }, customer) {
      let response = await Api.request('post', '/crmClients/createClients/' + this.state.fyId + '/' + this.state.organisationid + '/' + this.state.user.id + '', customer)
      let crmCustomer = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD__CRM_CUSTOMER', crmCustomer)
      }
      return response
    },
    async updateCrmCustomer({ commit }, customer) {
      let response = await Api.request('put', '/crmClients/updateClients/' + customer.id + '/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '', customer)
      let crmCustomer = response.data.data
      commit('UPDATE_CRM_CUSTOMER', crmCustomer)
      return response
    },
    async createCrmCompany({commit}, company) {
      let response = await Api.request('post', '/crmCompanies/createCompanies/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', company)
      let crmCompany = response.data.data
      if (response.status === 200) {
        commit('ADD_COMPANY', crmCompany)
      }
      return response
    },
    async updateCrmCompany({ commit }, company) {
      let response = await Api.request('put', '/crmCompanies/updateCompanies/' + company.id + '/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '', company)
      let crmCustomer = response.data.data
      commit('UPDATE_COMPANY', crmCustomer)
      return response
    },
    async createCrmDeal({commit}, deal) {
      console.log(deal)
      let response = await Api.request('post', '/crmDeals/createDeal/' + this.state.organisationid + '/' + this.state.user.id + '', deal)
      let crmDeal = response.data.data
      console.log(response)
      if (response.data.status === 'SUCCESS') {
        commit('ADD_DEAL', crmDeal)
      }
      return response
    },
    async updateCrmDeal({ commit }, deal) {
      let response = await Api.request('put', '/crmDeals/updateDeal/' + deal.id + '/' + this.state.user.id + '', deal)
      let crmCustomer = response.data.data
      commit('UPDATE_DEAL', crmCustomer)
      return response
    },
    async createCrmProduct({ commit }, product) {
      let response = await Api.request('post', '/crmProduct/createProduct/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', product)
      let crmProduct = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_PRODUCT', crmProduct)
      }
      return response
    },
    async updateCrmProduct({ commit }, deal) {
      let response = await Api.request('put', '/crmProduct/updateProduct/' + deal.id + '/' + this.state.user.id + '/' + this.state.fyId + '/' + this.state.organisationid + '', deal)
      let crmCustomer = response.data.data
      commit('UPDATE_PRODUCT', crmCustomer)
      return response
    },
    async createCrmTask({ commit }, task) {
      let response = await Api.request('post', '/crmTask/createTask/' + this.state.organisationid + '/' + this.state.user.id + '', task)
      let crmTask = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_TASK', crmTask)
      }
      return response
    },
    async updateCrmTask({ commit }, task) {
      let response = await Api.request('put', '/crmTask/updateTask/' + task.id + '/' + this.state.user.id + '', task)
      let crmCustomer = response.data.data
      commit('UPDATE_TASK', crmCustomer)
      return response
    },
    async createCrmVisitor({ commit }, visitor) {
      let response = await Api.request('post', '/crmVisitor/createVisitor/' + this.state.organisationid + '/' + this.state.user.id + '', visitor)
      let crmVisitor = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_VISITOR', crmVisitor)
      }
      return response
    },
    async updateCrmVisitor({ commit }, visitor) {
      let response = await Api.request('put', '/crmVisitor/updateVisitor/' + visitor.id + '/' + this.state.user.id + '', visitor)
      let crmCustomer = response.data.data
      commit('UPDATE_VISITOR', crmCustomer)
      return response
    },
    async createCrmTicket({ commit }, ticket) {
      let response = await Api.request('post', '/crmTicketDetails/createTicket/' + this.state.organisationid + '/' + this.state.user.id + '', ticket)
      let crmTicket = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_TICKET', crmTicket)
      }
      return response
    },
    async createCrmFollowUp({ commit }, followUp) {
      let response = await Api.request('post', '/crmFollowUp/saveNewFollowUp/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', followUp)
      let crmTicket = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_FOLLOW_UP', crmTicket)
      }
      return response
    },
    async updateCrmTicket({ commit }, ticket) {
      let response = await Api.request('put', '/crmTicketDetails/updateTicket/' + ticket.id + '/' + this.state.user.id + '', ticket)
      let crmCustomer = response.data.data
      commit('UPDATE_TICKET', crmCustomer)
      return response
    },
    async updateCrmFollowUp({ commit }, followUp) {
      let response = await Api.request('put', '/crmFollowUp/updateFollowUp/' + followUp.id + '/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '', followUp)
      console.log(response)
      let crmCustomer = response.data.data
      commit('UPDATE_FOLLOW_UP', crmCustomer)
      return response
    },
    async updateStageFollowUp({ commit }, followUp) {
      let encodedStageColor = encodeURIComponent(followUp.stageColor)
      let url = `/crmFollowUp/updateStageFollowUp/${followUp.id}/${this.state.user.id}/${this.state.organisationid}/${this.state.fyId}/${followUp.stage}/${encodedStageColor}`
      let response = await Api.request('put', url)
      let crmCustomer = response.data.data
      commit('UPDATE_FOLLOW_UP', crmCustomer)
      return response
    },
    async deleteCrmClient({ commit }, client) {
      let resp = await Api.request('delete', '/crmClients/deleteClients/' + client.accountMasterId + '/' + this.state.user.id + '/' + client.deleteReason)
      let deleteClient = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_CLIENT', deleteClient)
      }
      return resp
    },
    async deleteCrmCompany({ commit }, company) {
      let resp = await Api.request('delete', '/crmCompanies/deleteCompanies/' + company.accountMasterId + '/' + this.state.user.id + '/' + company.deleteReason)
      let deleteCrmCompany = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_COMPANY', deleteCrmCompany)
      }
      return resp
    },
    async deleteCrmCustomer({ commit }, customer) {
      let resp = await Api.request('delete', '/crmClients/deleteClients/' + customer.accountMasterId + '/' + this.state.user.id + '/' + customer.deleteReason)
      let deleteCrmCustomer = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_CUSTOMER', deleteCrmCustomer)
      }
      return resp
    },
    async deleteCrmDeal({ commit }, deal) {
      let resp = await Api.request('delete', '/crmDeals/deleteDeal/' + deal.accountMasterId + '/' + this.state.user.id + '/' + deal.deleteReason)
      let deleteCrmDeal = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_DEAL', deleteCrmDeal)
      }
      return resp
    },
    async deleteCrmTicket({ commit }, ticket) {
      let resp = await Api.request('delete', '/crmTicketDetails/deleteTicket/' + ticket.accountMasterId + '/' + this.state.user.id + '/' + ticket.deleteReason)
      let deleteCrmTicket = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_TICKET', deleteCrmTicket)
      }
      return resp
    },
    async deleteCrmProduct({ commit }, product) {
      let resp = await Api.request('delete', '/crmProduct/deleteProduct/' + product.productId + '/' + this.state.user.id + '/' + product.deleteReason)
      let deleteCrmProduct = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_PRODUCT', deleteCrmProduct)
      }
      return resp
    },
    async deleteCrmVisitor({ commit }, visitor) {
      let resp = await Api.request('delete', '/crmVisitor/deleteVisitor/' + visitor.accountMasterId + '/' + this.state.user.id + '/' + visitor.deleteReason)
      let deleteCrmVisitor = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_VISITOR', deleteCrmVisitor)
      }
      return resp
    },
    async deleteCrmTask({ commit }, task) {
      let resp = await Api.request('delete', '/crmTask/deleteTask/' + task.accountMasterId + '/' + this.state.user.id + '/' + task.deleteReason)
      let deleteCrmTask = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_Task', deleteCrmTask)
      }
      return resp
    },
    async deleteCrmFollowUp({ commit }, followUp) {
      let resp = await Api.request('delete', '/crmFollowUp/deleteFollowUp/' + followUp.id + '/' + this.state.user.id + '/' + followUp.deleteReason)
      let deleteCrmFollowUp = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_Follow_Up', deleteCrmFollowUp)
      }
      return resp
    },
    async loadCrmClientList({ commit }) {
      let response = await Api.request('get', '/crmClients/clientsList/' + this.state.organisationid + '/' + this.state.fyId)
      commit('SET_CLIENT', response.data.data)
      console.log(response.data.data)
    },
    async loadCrmCompanyList({ commit }) {
      let response = await Api.request('get', '/crmCompanies/companiesList/' + this.state.organisationid + '/' + this.state.fyId, null)
      commit('SET_COMPANY', response.data.data)
      return response
    },
    async loadCrmCustomerList({ commit }) {
      let response = await Api.request('get', '/crmClients/clientsList/' + this.state.organisationid + '/' + this.state.fyId)
      commit('SET_CRM_CUSTOMER', response.data.data)
    },
    async loadCrmDealList({ commit }) {
      let response = await Api.request('get', '/crmDeals/dealList/' + this.state.organisationid, null)
      commit('SET_DEAL', response.data.data)
      return response
    },
    async loadCrmProductList({ commit }) {
      let response = await Api.request('get', '/crmProduct/productList/' + this.state.organisationid + '/' + this.state.fyId, null)
      commit('SET_PRODUCT', response.data.data)
      return response
    },
    async loadCrmTaskList({ commit }) {
      let response = await Api.request('get', '/crmTask/taskList/' + this.state.organisationid, null)
      commit('SET_TASK', response.data.data)
      return response
    },
    async loadCrmTicketList({ commit }) {
      let response = await Api.request('get', '/crmTicketDetails/ticketList/' + this.state.organisationid + '')
      commit('SET_TICKET', response.data.data)
      return response
    },
    async loadCrmVisitorList({ commit }) {
      let response = await Api.request('get', '/crmVisitor/visitorList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_VISITOR', response.data.data)
    },
    async loadCrmFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_FOLLOWUP', response.data.data)
      return response
    },
    async loadCrmAllFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/crmAllList/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_FOLLOWUP_ALL', response.data.data)
      return response
    },
    async fetchNotifications({ dispatch }) {
      await Promise.all([
        dispatch('loadCrmFollowUpNotification'),
        dispatch('getUnreadNotificationCount')
      ])
    },
    async loadCrmFollowUpNotification({ commit }) {
      const response = await Api.request(
        'get',
        `/crmFollowUp/notifications/follow-ups/all/${this.state.organisationid}/${this.state.fyId}/${this.state.user.id}`
      )
      commit('SET_FOLLOWUP_NOTIFICATION', response.data.data)
      return response.data.data
    },
    async getUnreadNotificationCount({ commit }) {
      const response = await Api.request(
        'get',
        `/crmFollowUp/notifications/unread-count/${this.state.organisationid}/${this.state.fyId}/${this.state.user.id}`
      )
      commit('SET_UNREAD_COUNT', response.data.data.count)
      return response.data.data.count
    },
    async markNotificationAsRead({ commit }, notification) {
      console.log(notification)
      const type = notification.followUpNotificationDTO ? 'followup' : 'outInvoice'
      const id = notification.followUpNotificationDTO
                ? notification.followUpNotificationDTO.followUpId
                : notification.unpaidInvoiceNotificationDTO.id
      console.log('id' + id + 'type' + type)
      await Api.request('put', `/crmFollowUp/notifications/mark-read/${id}/${type}`)
      commit('REMOVE_NOTIFICATION', id)
      this.dispatch('getUnreadNotificationCount')
    },
    async markNotificationsAsRead({ commit }, notifications) {
      try {
        console.log(notifications)
        const payload = notifications.map(n => ({
          followUpNotificationDTO: n.followUpNotificationDTO || null,
          unpaidInvoiceNotificationDTO: n.unpaidInvoiceNotificationDTO || null
        }))
        console.log('payload' + payload)
        const response = await Api.request('put', '/crmFollowUp/notifications/mark-read-all', payload)
        console.log(response)
        if (response.data.status === 'SUCCESS') {
          const ids = notifications.map(n =>
            n.followUpNotificationDTO
              ? n.followUpNotificationDTO.followUpId
              : n.unpaidInvoiceNotificationDTO.id
          )
          commit('REMOVE_NOTIFICATIONS', ids)
          this.dispatch('getUnreadNotificationCount')
        }
        return response
      } catch (error) {
        console.error('Error marking notifications as read:', error)
        throw error
      }
    },
    async loadCrmFollowUpListByCustomerType({ commit }, params) {
      let response = await Api.request('get', '/crmFollowUp/followUpByCustomerType/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '?from=' + params.fromDate + '&to=' + params.toDate + '&customerType=' + params.customerTypes)
      commit('SET_FOLLOWUP', response.data.data)
      return response
    },
    async loadTodayCrmFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/todayFollowUp/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '')
      commit('SET_FOLLOWUP', response.data.data)
      return response
    },
    async loadAllTodayCompeltedCrmFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/totalTodayFollowUp/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '')
      commit('SET_FOLLOWUP', response.data.data)
      return response
    },
    async loadAllnotReceivedCallsCrmFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/notReceivedCalls/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '')
      commit('SET_FOLLOWUP_NOT_RECEIVED', response.data.data)
      return response
    },
    async loadCrmFollowUpListByDateRange({ commit }, params) {
      let response = await Api.request('get', '/crmFollowUp/followUpBetweenDate/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '?from=' + params.fromDate + '&to=' + params.toDate)
      commit('SET_FOLLOWUP_DATE_RANGE', response.data.data)
      return response
    },
    async loadAllQuotationSentFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/quotationSampleSent/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '/' + true + '/' + false)
      commit('SET_QUOTATION', response.data.data)
      return response
    },
    async loadAllSampleSentFollowUpList({ commit }) {
      let response = await Api.request('get', '/crmFollowUp/quotationSampleSent/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '/' + false + '/' + true)
      commit('SET_SAMPLE', response.data.data)
      return response
    },
    async loadCRMStageWiseGraphData({ commit }, data) {
      const stages = data.stages === null || data.stages === 'null' ? 'null' : data.stages
      const stagesParam = encodeURIComponent(stages)
      const url = `/crmFollowUp/crm/followup/stage-count/${this.state.organisationid}/${this.state.fyId}/${this.state.user.id}?fromDate=${data.from}&toDate=${data.to}&stages=${stagesParam}`
      try {
        let response = await Api.request('get', url)
        if (response.data.status === 'SUCCESS') {
          return response.data.data[0]
        }
      } catch (error) {
        console.error('Error fetching weekly target sales data:', error)
        return null
      }
    },
    async loadCRMUserWiseMonthlyGraphData({ commit }, { month, users }) {
      const baseUrl = `/crmFollowUp/crm/followup/monthly-user-count/${this.state.organisationid}/${this.state.fyId}/${this.state.user.id}`
      const params = new URLSearchParams()
      params.append('monthName', month)
      if (users && Array.isArray(users) && users.length > 0) {
        params.append('userIds', users.join(','))
      }
      const url = `${baseUrl}?${params.toString()}`
      try {
        const response = await Api.request('get', url)
        if (response.data.status === 'SUCCESS') {
          return response.data.data[0]
        } else {
          console.warn('API response not successful:', response.data.message)
          return null
        }
      } catch (error) {
        console.error('Error fetching monthly user-wise follow-up data:', error)
        return null
      }
    },
    async loadCRMUserWiseGraphData({ commit }, { from, to, userIds }) {
      const baseUrl = `/crmFollowUp/crm/followup/user-count/${this.state.organisationid}/${this.state.fyId}/${this.state.user.id}`
      const params = new URLSearchParams()
      params.append('fromDate', from)
      params.append('toDate', to)
      if (userIds && userIds.length > 0) {
        params.append('userIds', userIds.join(','))
      }
      const url = `${baseUrl}?${params.toString()}`
      try {
        let response = await Api.request('get', url)
        if (response.data.status === 'SUCCESS') {
          return response.data.data[0] || null
        } else {
          console.warn('API response not successful:', response.data.message)
          return null
        }
      } catch (error) {
        console.error('Error fetching user-wise follow-up data:', error)
        return null
      }
    }
  },
  get actions() {
    return this._actions
  },
  set actions(value) {
    this._actions = value
  },
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store/crm.js